<template>
    <router-view />
</template>

<script setup>

import router from "@/router";
import { onMounted, ref, watch } from "vue";
import { apiAppDataCollect } from "@/services/data";
import { get } from "lodash-es";

let time = 10;
const handler = ref(null)


const loopRecording = () => {
    if (get(router.currentRoute.value.query, 'mock')){
        return;
    }
    if (router.currentRoute.value.name === 'user.login') {
        return
    }
    if (handler.value) {
        return
    }
    let startLooping = function () {
        apiAppDataCollect({
            'seconds': time,
            'sys': 2
        }).then(({ success, data }) => {
            if (success) {
                time = Number(get(data, 'time'));
                handler.value = setTimeout(() => {
                    startLooping()
                }, time * 1000)
            }
        })
    }
    handler.value = setTimeout(() => {
        startLooping();
    }, time * 1000)
}

onMounted(() => {
    // 延迟两秒执行
    setTimeout(() => {
        loopRecording();
    }, 2000)
})

watch(() => router.currentRoute.value, (newVal, oldVal) => {
    // 其他页面来到登录, 取消掉 handler , 取消掉定时
    if (newVal.name === 'user.login') {
        if (handler.value) {
            clearTimeout(handler.value)
        }
        handler.value = null
    }
    else {
        // 登录页面来到其他页面, 清除 handler , 开始记录
        if (oldVal.name === 'user.login') {
            if (handler.value) {
                clearTimeout(handler.value)
            }
            handler.value = null;
            loopRecording()
        }
    }
}, {
    deep: true
})


</script>

